//IMPORT NEW DATAMODEL

export class NDataModel {
//DECLARE NEW VARIABLE

constructor() {
//CREATE NEW DM INSTANCE
    }
}
